import { render, staticRenderFns } from "./marketSegmentGroup.vue?vue&type=template&id=3afa104a&scoped=true"
import script from "./marketSegmentGroup.vue?vue&type=script&lang=js"
export * from "./marketSegmentGroup.vue?vue&type=script&lang=js"
import style0 from "./marketSegmentGroup.vue?vue&type=style&index=0&id=3afa104a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa104a",
  null
  
)

export default component.exports